import * as Yup from "yup";

export const certificateSchema = Yup.object({
  regNumber: Yup.string().required("Certificate number is required"),
});
